<template>
  <div>
    <HeaderPage href="/contact" />
    <div class="container_wrap">
      <div class="neiBanner">
        <div class="textBanner wow">
          <dl>CONTACT US</dl>
          <div class="solid"></div>
          <dt>联系我们</dt>
        </div>
      </div>
      <div class="contact">
        <div class="wrap">
          <div class="tit wow">
            <h3>欢迎访问浙江国正安全技术有限公司</h3>
            请用如下方式联系我们
          </div>
          <div class="box wow ">
            <ul class="flex justify-center">
              <li>
                <i><img src="@/assets/images/icon/km3XOK.png" alt=""></i>
                <h3>电话</h3>
                <dt>
                  86-0575-84818999<br>86-0575-85566277
                </dt>
              </li>
              <li>
                <i><img src="@/assets/images/icon/cXL0Yn.png" alt=""></i>
                <h3>电子邮箱</h3>
                <dt>
                  guozhengjiance@163.com<br> xyz@163.com
                </dt>
              </li>
              <li>
                <i><img src="@/assets/images/icon/F8C4yN.png" alt=""></i>
                <h3>地址</h3>
                <dt>
                  浙江省绍兴市柯桥区华舍街道金柯桥大道1358号国贸大厦17-20 楼
                </dt>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <FooterPage />
  </div>
</template>

<script setup>
import { onMounted, onUnmounted } from 'vue';
// 组件逻辑
import HeaderPage from '@/components/HeaderPage.vue'
import FooterPage from '@/components/FooterPage.vue'


let intervalId


const stopAutoScroll = () => {
  clearInterval(intervalId)
}

onMounted(() => {

  // ✅ 滚动动画逻辑
  const elements = document.querySelectorAll('.wow')
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const el = entry.target
        const animateName = el.dataset.animate || 'fadeInUp'
        if (entry.isIntersecting) {
          el.classList.add('animated', animateName)
          // ✅ 添加后立即取消观察，避免重复触发
          observer.unobserve(el)
        }
      })
    },
    { threshold: 0.2 }
  )
  elements.forEach((el) => observer.observe(el))
  onUnmounted(() => {
    elements.forEach((el) => observer.unobserve(el))
    stopAutoScroll()
  })
})

</script>

<style scoped>
.neiBanner {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background: url('@/assets/images/bg/XbwzQL.jpg') no-repeat center;
  background-size: 100% 100%;
}

.neiBanner .textBanner {
  color: #fff;
  text-align: center;
  padding-top: 200px;
}

.neiBanner .textBanner dl {
  font-size: 42px;
}

.neiBanner .textBanner .solid {
  height: 1px;
  background-color: #fff;
  margin: 15px 0;
  box-sizing: border-box;
}

.neiBanner .textBanner dt {
  font-size: 20px;
  font-weight: 500;

}

.contact {
  padding: 70px 0 100px;
}

.contact .tit {
  font-size: 24px;
  text-align: center;
  color: #666666;
  line-height: 1.8;
  margin-bottom: 60px;
}

.contact .tit h3 {
  font-size: 30px;
  font-weight: normal;
}

.contact .box ul {
  width: 100%;
}

.contact .box ul li {
  width: 390px;
  text-align: center;
}

.contact .box ul li i {
  width: 66px;
  height: 66px;
  line-height: 60px;
  border: #b68a49 solid 1px;
  border-radius: 66px;
  display: block;
  margin: 0 auto 20px;
}

.contact .box ul li h3 {
  font-size: 16px;
  color: #b68a49;
  font-weight: 500;
  line-height: 1;
  margin-bottom: 40px;
}

.contact .box ul li dt {
  font-size: 18px;
  font-weight: normal;
  color: #666;
}
</style>